import React from 'react';
import styled from 'styled-components';

const PercentageWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 72px;
	height: 72px;
	border-radius: 50%;
	background-color: ${props => `${props.theme.colors.primary}88`};

	@media ${props => props.theme.device.tablet} {
		width: 40px;
		height: 40px;
	}

	@media ${props => props.theme.device.smTablet} {
		width: 40px;
		height: 40px;
	}

	@media ${props => props.theme.device.mobile} {
		width: 40px;
		height: 40px;
	}
`;

const PercentageBackground = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: #ffffff;

	@media ${props => props.theme.device.tablet} {
		width: 36px;
		height: 36px;
	}

	@media ${props => props.theme.device.smTablet} {
		width: 36px;
		height: 36px;
	}

	@media ${props => props.theme.device.mobile} {
		width: 36px;
		height: 36px;
	}
`;

const PercentageContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 56px;
	height: 56px;
	border-radius: 50%;
	background-color: #ECECEC;

	@media ${props => props.theme.device.tablet} {
		width: 32px;
		height: 32px;
	}

	@media ${props => props.theme.device.smTablet} {
		width: 32px;
		height: 32px;
	}

	@media ${props => props.theme.device.mobile} {
		width: 32px;
		height: 32px;
	}
`;

const Percentage = styled.p`
	margin: 0;
	font-size: 12px;
	color: ${props => props.theme.colors.primary};

	@media ${props => props.theme.device.tablet} {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 10px;
		line-height: 12px;
	}

	@media ${props => props.theme.device.smTablet} {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 10px;
		line-height: 12px;
	}

	@media ${props => props.theme.device.mobile} {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 10px;
		line-height: 12px;
	}
`;

const Value = styled.span`
	margin-bottom: 2px;
	font-size: 14px;

	@media ${props => props.theme.device.lgDesktop} {
		margin-right: 4px;
		margin-bottom: 0;
		font-size: 18px;
	}

	@media ${props => props.theme.device.desktop} {
		margin-right: 4px;
		margin-bottom: 0;
		font-size: 18px;
	}
`;

interface IHomeworkPercentage {
	percentage: number | string;
}

const HomeworkPercentage = ({ percentage }: IHomeworkPercentage): JSX.Element => (
	<PercentageWrapper>
		<PercentageBackground>
			<PercentageContent>
				<Percentage>
					<Value>{percentage}</Value>
					<span>%</span>
				</Percentage>
			</PercentageContent>
		</PercentageBackground>
	</PercentageWrapper>
);

export default HomeworkPercentage;
